import AnnualReportComponent from '@/container/annualReport'

let $vm

const plugin = {
  install (vue, options = {}) {
    const AnnualReport = vue.extend(AnnualReportComponent)

    if (!$vm) {
      $vm = new AnnualReport({
        el: document.createElement('div')
      })
      $vm.router = options.router
      document.body.appendChild($vm.$el)
    }

    vue.prototype.$annualReport = {
      show (userId, step = 0) {
        $vm.userId = userId
        $vm.showValue = true
        $vm.step = step
      },
      setUserId (userId) {
        $vm.userId = userId
      }
    }
  }
}

export default plugin
